import { Bug } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const BugIcon = DeckardIconWrapper({ Icon: Bug });
